/**
 * Shared cancellation modal state helpers. Used by appointments-table and schedule-appointment-modal.
 */
export interface CancellationModalState {
  isCancellationSuccessModalVisible: boolean;
  isCancellationErrorModalVisible: boolean;
  appointmentToCancel: any;
}

export function clearCancellationModalsAndAppointment(state: CancellationModalState): void {
  state.isCancellationSuccessModalVisible = false;
  state.isCancellationErrorModalVisible = false;
  state.appointmentToCancel = null;
}
